import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../../components/common/PageHeader';
import PAMMFundForm, {
  PAMMFundFormValues,
} from '../components/shared/PAMMFundForm';
import { pammFundService } from '../services/pammService';
import { PAMM_ROUTES } from '../../../constants/routeConstants';
import toast from 'react-hot-toast';

export default function CreateFund() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const scrollEl = document.querySelector('main .overflow-y-auto');
    if (scrollEl) {
      scrollEl.scrollTop = 0;
    }
  }, []);

  const handleSubmit = async (
    formValues: PAMMFundFormValues,
    selectedSymbols: string[]
  ) => {
    try {
      setSubmitting(true);
      await pammFundService.create({
        ...formValues,
        minimumInvestment: Number(formValues.minimumInvestment),
        maximumInvestment: Number(formValues.maximumInvestment),
        performanceFee: Number(formValues.performanceFee),
        managementFee: Number(formValues.managementFee),
        entryFee: Number(formValues.entryFee),
        exitFee: Number(formValues.exitFee),
        lockPeriodDays: Number(formValues.lockPeriodDays),
        tradingSymbols: selectedSymbols,
        allocationMethod: formValues.allocationMethod,
        riskLevel: formValues.riskLevel,
      });
      toast.success('Fund created successfully! Pending approval.');
      navigate(PAMM_ROUTES.PAMM_FUND_MANAGEMENT);
    } catch {
      toast.error('Failed to create fund. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Create New Fund"
        description="Configure a new PAMM fund for investor allocations"
      />
      <PAMMFundForm
        mode="create"
        submitting={submitting}
        onSubmit={handleSubmit}
        onCancel={() => navigate(-1)}
      />
    </div>
  );
}
